"use client";

import { type LastAddedListItemType } from "../../types/last-added.type";
import { CateringCarouselItem } from "./caterings-carousel-item";
import { Marquee } from "@/components/marquee";

export const CateringsCarousel = ({
  data,
}: {
  data: (LastAddedListItemType & { logoUrl?: string })[];
}) => {
  return (
    <>
      {data && (
        <Marquee
          data={data}
          renderItem={(item) => <CateringCarouselItem data={item} />}
        />
      )}
    </>
  );
};
